export const messages = {
    gb: {
        important: 'Important',
        turnLocation: 'Please turn on your phone location.',
        parish: 'Parish of Quinta Grande',
        interests: 'Points of Interest',
        chooseLanguage: 'Choose a language',
        seeMorePhotos: 'See more photos',
        leaveApp: 'Leave App?',
        leaveAppConfirm: 'Are you sure you want to leave the app and visit jf-quintagrande.pt?',
        cancel: 'Cancel',
        yes: 'Yes',
points: {
"caminha-joao-de-almada": {
    name: "Caminha João de Almada",
    description: "An iconic location with specific coordinates, offering points of interest to explore.",
},
"viewpoint-partilha": {
    name: "Miradouro da Partilha",
    description: "A small forest park with hiking trails, picnic areas, and the opportunity to experience Madeira's lush vegetation.",
},
"geodetic-point": {
    name: "Geodetic Point",
    description: "An important landmark for geographic measurement and local terrain reference.",
},
"caminho-das-fontinhas": {
    name: "Caminho das Fontinhas",
    description: "A pleasant route with natural landscapes, ideal for hiking and connecting with nature.",
},
"caminho-do-arieiro": {
    name: "Caminho do Arieiro",
    description: "A trail with stunning views and connection between the region's high points.",
},
"estrada-joao-goncalves-zaco": {
    name: "Estrada João Gonçalves Zaco",
    description: "A road linking various points of interest, with views and easy access.",
},
"estrada-padre-antonio-silvino-de-andrade": {
    name: "Estrada Padre António Silvino de Andrade",
    description: "A local route with historical importance and connection between communities.",
},
"levada-do-norte": {
    name: "Levada do Norte",
    description: "Famous Madeiran levada, ideal for hiking and contact with the island's unique nature.",
},
"levada-do-norte-2": {
    name: "Levada do Norte - Section 2",
    description: "Continuation of Levada do Norte, with more landscapes and points of interest to explore.",
},
"vereda-do-pe-da-rocha": {
    name: "Vereda do Pé da Rocha",
    description: "A natural trail with beautiful landscapes and an authentic hiking experience in Madeira.",
}
}

    },
    pt: {
        important: 'Importante',
        turnLocation: 'Por favor, ligue a sua localização.',
        parish: 'Freguesia da Quinta Grande',
        interests: 'Pontos de Interesse',
        chooseLanguage: 'Escolha uma línguagem',
        seeMorePhotos: 'Ver mais fotos',
        leaveApp: 'Sair da App?',
        leaveAppConfirm: 'Tem a certeza que deseja sair da app e visitar jf-quintagrande.pt?',
        cancel: 'Cancelar',
        yes: 'Sim',
        points: {
"caminha-joao-de-almada": {
    name: "Caminha João de Almada",
    description: "Local emblemático com coordenadas específicas, oferecendo pontos de interesse para explorar.",
},
"viewpoint-partilha": {
    name: "Miradouro da Partilha",
    description: "Um pequeno parque florestal com trilhos para caminhadas, áreas para piqueniques e oportunidade de experienciar a vegetação exuberante da Madeira.",
},
"geodetic-point": {
    name: "Ponto Geodésico",
    description: "Um marco importante para a medição geográfica e referência do terreno local.",
},
"caminho-das-fontinhas": {
    name: "Caminho das Fontinhas",
    description: "Uma rota agradável com paisagens naturais, ideal para caminhadas e contacto com a natureza.",
},
"caminho-do-arieiro": {
    name: "Caminho do Arieiro",
    description: "Percurso com vistas deslumbrantes e ligação entre os pontos altos da região.",
},
"estrada-joao-goncalves-zaco": {
    name: "Estrada João Gonçalves Zaco",
    description: "Estrada que liga vários pontos de interesse, com vistas e acessos facilitados.",
},
"estrada-padre-antonio-silvino-de-andrade": {
    name: "Estrada Padre António Silvino de Andrade",
    description: "Via local com importância histórica e ligação entre comunidades.",
},
"levada-do-norte": {
    name: "Levada do Norte",
    description: "Famosa levada madeirense, ideal para caminhadas e contacto com a natureza única da ilha.",
},
"levada-do-norte-2": {
    name: "Levada do Norte - Secção 2",
    description: "Continuação da Levada do Norte, com mais paisagens e pontos de interesse para explorar.",
},
"vereda-do-pe-da-rocha": {
    name: "Vereda do Pé da Rocha",
    description: "Trilho natural com belas paisagens e uma experiência de caminhada autêntica na Madeira.",
}

        },
    },
    fr: {
        important: 'Important',
        turnLocation: 'Veuillez activer la localisation de votre téléphone.',
        parish: 'Paroisse de Quinta Grande',
        interests: 'Points d’intérêt',
        chooseLanguage: 'Choisissez une langue',
        seeMorePhotos: 'Voir plus de photos',
        leaveApp: 'Quitter l\'application?',
        leaveAppConfirm: 'Êtes-vous sûr de vouloir quitter l\'application et visiter jf-quintagrande.pt?',
        cancel: 'Annuler',
        yes: 'Oui',
        points: {
"caminha-joao-de-almada": {
    name: "Caminha João de Almada",
    description: "Un lieu emblématique avec des coordonnées spécifiques, offrant des points d'intérêt à explorer.",
},
"viewpoint-partilha": {
    name: "Miradouro da Partilha",
    description: "Un petit parc forestier avec des sentiers de randonnée, des aires de pique-nique et la possibilité de découvrir la végétation luxuriante de Madère.",
},
"geodetic-point": {
    name: "Point Géodésique",
    description: "Un repère important pour la mesure géographique et la référence du terrain local.",
},
"caminho-das-fontinhas": {
    name: "Caminho das Fontinhas",
    description: "Un itinéraire agréable avec des paysages naturels, idéal pour la randonnée et le contact avec la nature.",
},
"caminho-do-arieiro": {
    name: "Caminho do Arieiro",
    description: "Un sentier avec des vues impressionnantes et une connexion entre les points culminants de la région.",
},
"estrada-joao-goncalves-zaco": {
    name: "Estrada João Gonçalves Zaco",
    description: "Une route reliant plusieurs points d'intérêt, avec des vues et un accès facile.",
},
"estrada-padre-antonio-silvino-de-andrade": {
    name: "Estrada Padre António Silvino de Andrade",
    description: "Une voie locale d'importance historique reliant les communautés.",
},
"levada-do-norte": {
    name: "Levada do Norte",
    description: "Fameuse levada de Madère, idéale pour la randonnée et le contact avec la nature unique de l'île.",
},
"levada-do-norte-2": {
    name: "Levada do Norte - Section 2",
    description: "Suite de la Levada do Norte, avec plus de paysages et de points d'intérêt à explorer.",
},
"vereda-do-pe-da-rocha": {
    name: "Vereda do Pé da Rocha",
    description: "Un sentier naturel avec de beaux paysages et une expérience de randonnée authentique à Madère.",
}

        },
    },
    de: {
        important: 'Wichtig',
        turnLocation: 'Bitte schalten Sie den Standort Ihres Telefons ein.',
        parish: 'Gemeinde Quinta Grande',
        interests: 'Sehenswürdigkeiten',
        chooseLanguage: 'Wählen Sie eine Sprache',
        seeMorePhotos: 'Mehr Fotos ansehen',
        leaveApp: 'App verlassen?',
        leaveAppConfirm: 'Sind Sie sicher, dass Sie die App verlassen und jf-quintagrande.pt besuchen möchten?',
        cancel: 'Abbrechen',
        yes: 'Ja',
        points: {
"caminha-joao-de-almada": {
    name: "Caminha João de Almada",
    description: "Ein ikonischer Ort mit genauen Koordinaten, der interessante Punkte zum Erkunden bietet.",
},
"viewpoint-partilha": {
    name: "Miradouro da Partilha",
    description: "Ein kleiner Waldpark mit Wanderwegen, Picknickbereichen und der Möglichkeit, die üppige Vegetation Madeiras zu erleben.",
},
"geodetic-point": {
    name: "Geodätischer Punkt",
    description: "Ein wichtiger Orientierungspunkt für geografische Messungen und lokale Geländereferenz.",
},
"caminho-das-fontinhas": {
    name: "Caminho das Fontinhas",
    description: "Eine angenehme Route mit natürlichen Landschaften, ideal zum Wandern und zur Verbindung mit der Natur.",
},
"caminho-do-arieiro": {
    name: "Caminho do Arieiro",
    description: "Ein Weg mit beeindruckenden Aussichten und Verbindung zwischen den Höhenpunkten der Region.",
},
"estrada-joao-goncalves-zaco": {
    name: "Estrada João Gonçalves Zaco",
    description: "Eine Straße, die verschiedene Sehenswürdigkeiten verbindet, mit Aussichten und einfacher Zugänglichkeit.",
},
"estrada-padre-antonio-silvino-de-andrade": {
    name: "Estrada Padre António Silvino de Andrade",
    description: "Eine lokale Straße mit historischer Bedeutung und Verbindung zwischen Gemeinden.",
},
"levada-do-norte": {
    name: "Levada do Norte",
    description: "Berühmte Levade auf Madeira, ideal zum Wandern und für den Kontakt mit der einzigartigen Natur der Insel.",
},
"levada-do-norte-2": {
    name: "Levada do Norte - Abschnitt 2",
    description: "Fortsetzung der Levada do Norte mit weiteren Landschaften und interessanten Punkten zum Erkunden.",
},
"vereda-do-pe-da-rocha": {
    name: "Vereda do Pé da Rocha",
    description: "Ein Naturpfad mit schönen Landschaften und einem authentischen Wandererlebnis auf Madeira.",
}

        },
    }
}
